module.exports = __webpack_public_path__ + "img/60f7.d2c0e1f2.jpg";